import Box from '@mui/material/Box/Box';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DisplayEuroMUI } from 'src/utils/formats';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import { getUnternehmenDisplayName } from 'src/utils/ausgabenFinanzierungHelper';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const SachkostenUebersichtAntragLoewe: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		// { field: 'id', headerName: 'ID', width: 80, groupable: false },
		// { field: 'kostraeger', headerName: 'Kostenträger', flex: 1 },
		{ field: 'unternehmen', headerName: 'Unternehmen / Institution', width: 180 },
		{ field: 'bezeichnung', headerName: 'Bezeichnung', flex: 1, groupable: false },
		// { field: 'kostenart', headerName: 'Kostenart', flex: 1, groupable: false },
		{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
		...Array.from({ length: get(application, P.Allgemein_Projektdauerin_Jahren.path) }).map((_, i) => {
			return {
				field: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
				headerName: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return value ? DisplayEuroMUI(value) : 0;
				},
			};
		}),
		{
			field: 'gesamtSumme',
			headerName: 'Geplante Gesamtsumme (€)',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : 0;
			},
		},
	];

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === 'Sachkosten')
			.map((ele: any) => {
				const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).reduce((acc: any, proJahr: any) => {
					acc[get(proJahr, 'Zelle_1')] = get(proJahr, 'Zelle_2');
					return acc;
				}, {});
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: getUnternehmenDisplayName(application, ele),
					bezeichnung: get(ele, KP_P.Allgemein_Bezeichnung.path),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					...kostenProJahr,
					gesamtSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					gesamtSumme: 'sum',
				},
			},
			columns: {
				columnVisibilityModel: {
					// Hide the column used for leaves
					unternehmen: false,
				},
			},
			rowGrouping: {
				model: ['unternehmen'],
			},
		};
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Sachkosten Übersicht' description={PLATZHALTER_TEXT} />
			<Box sx={{ height: 'auto', width: '100%' }}>
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					groupingColDef={{
						headerName: 'Organisation',
						valueFormatter: (value: any) => value ?? 'Gesamt',
					}}
					hideFooter
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</Box>
		</>
	);
};
export default SachkostenUebersichtAntragLoewe;
